export interface AttributeSource {
  getAttributes(): Record<string, string>;
}

export const EMPTY_ATTRIBUTE_SOURCE: AttributeSource = { getAttributes: () => ({}) };
